$(document).ready(function(){
    /* section toggler */
    let windowWidth = $(window).width();
    let isMobile = windowWidth < 576;
    let isTablet = windowWidth >= 576 && windowWidth < 992;
    let isBrowser = windowWidth >= 992;
    (function(){
        let element = $(".section-toggler");
        element.click(function(){
            let destination = $($(this).attr("data-destination"));
            destination.slideToggle(300);
            $(this).toggleClass("expanded");
        })
    })();
    /* slider height adjustment accordding to media height  */
    (function(){
        let slider = $(".slider-section .item");
        let imageHeight = slider.find("img").height();
        let sliderHeight = $(window).height() - $(".site-header .bottom-header").height();
        if(imageHeight > sliderHeight){
            slider.css({
                maxHeight : sliderHeight
            })
        }
    })();
    /* add background images */
    (function imageToBackground(){
        let section = $(".image-as-bg");
        section.each(function(){
            let imageSource = $(this).attr("data-bg");
            let browserHeight = $(this).attr("data-browser-height") ? $(this).attr("data-browser-height") : `auto`;
            let mobileHeight = $(this).attr("data-mobile-height") ? $(this).attr("data-mobile-height") : browserHeight;
            let tabletHeight = $(this).attr("data-tablet-height") ? $(this).attr("data-tablet-height") : browserHeight;
            let height;
            if(isMobile){
                height=mobileHeight;
            }else if(isTablet){
                height=tabletHeight;
            }else{
                height=browserHeight
            }
            let bg = $(this).attr("data-styles") ? $(this).attr("data-styles") : "no-repeat center / cover";
            $(this).css({
                "background":`url(${imageSource}) ${bg}`,
                "height" : (height !== `auto`) ? `${height}px` : height 
            });
        });
    })();
    /* responsive paragraph collapsible accordion */
    (function mobileResponsiveParagraphCollapse() {
        let parent = $(".paragraph-collapsible");
        let element = parent.find("p:nth-child(odd)");
        parent.find("p:nth-child(even)").not($(".shown").next()).hide();
        element.click(function() {
            parent.find("p:nth-child(odd)").not($(this)).removeClass("shown");
            parent.find("p:nth-child(even)").not($(this).next()).slideUp();
            $(this).toggleClass("shown");
            $(this).next().slideToggle();
        });
    })();
    (function fixNavigation(){
        let navbar = $("#navbarSupportedContent");
        if(isBrowser){
            navbar.find(".nav-item.dropdown").each(function(){
                let len = $(this).find(".dropdown").length;
                if(len > 1 && len <=4){
                    $(this).addClass(`has-${len}-menu`);
                }
            })
        }
        if(isMobile || isTablet){
            let altermenu = $("#alter-menu-list");
            let newMenu = '';
            let logo = $("#logo-top");
            let admin = $("#admin-links");
            let logoSection = $(".logo-menu-section");
            altermenu.find(".dropdown-item").each(function(){
                let link = $(this).attr("href");
                let html = $(this).html();
                newMenu += `
                <li class="nav-item">
                    <a class="nav-link" href="${link}">${html}</a>
                </li>
                `
            })
            navbar.find(".navbar-nav").append(newMenu);
            altermenu.parent().remove();
            $(".store-link").parent().remove();
            logoSection.prepend(logo);
            logoSection.parent().append(admin);
        }

    })();
    /* scrollable navs */
    (function scrollToElement(){
        let tabs = $(".nav-scrollable");
            tabs.each(function(){
                let scroller = $(this).find(".nav-link");
                let formHtml = `
                <div class="form-group mb-0 icon-group d-md-none without-label" >
                    <select class="form-control nav-select">`;
                scroller.each(function(){
                    formHtml += `<option value="${$(this).attr("aria-controls")}">${$(this).html()}</option>`
                })
                formHtml+=`
                    </select>
                    <i class="ion ion-ios-arrow-down"></i>
                </div>`
                $(formHtml).insertAfter($(this));
                scroller.click(function(e){
                    let scrollDestination = $(`#${$(this).attr("aria-controls")}`);
                    $("html,body").animate({
                        scrollTop:scrollDestination.offset().top
                    },300);
                    e.preventDefault();
                });
                $(".nav-select").change(function(e){
                    let scrollDestination = $(`#${$(this).find('option:selected').val()}`);
                    $("html,body").animate({
                        scrollTop:scrollDestination.offset().top
                    },300);
                    e.preventDefault();
                })
            })
    })();
    (function deviceRelativeItem(){
        let mobile = $(".only-mobile");
        let tablet = $(".only-tablet");
        let browser = $(".only-browser");
        if(isBrowser){
            mobile.remove();
            browser.removeClass("only-browser");
            $("body").addClass("browser-device");
        }
        if(isTablet){
            tablet.remove();
            browser.removeClass("only-tablet");
            $("body").addClass("tablet-device");
        }
        if(isMobile){
            browser.remove();
            mobile.removeClass("only-mobile");
            $("body").addClass("mobile-device");
        }
    })();
    (function copyUrl(){
        let button = $(".copy-url");
        button.click(function(e){
            e.preventDefault();
            let input = $(this).prev();
            let currentURL=decodeURI(location.href);
            input.val(currentURL);
            input.select();
            document.execCommand("copy");
            console.log(input);
            button.prepend(`<small class="bg-success-color success-text">Url is copied.</small>`);
            setTimeout(() => {
                $(".success-text").fadeOut(300);
            },3000)
            setTimeout(() => {
                $(".success-text").remove();
            },3300)
        })
    })();
    (function enableDatepicker(){
        let datepick = $(".datepick input");
        datepick.change(function(){
            let datepickerInput = $(this).parent().next().find("input");
            let oldPlaceholder = datepickerInput.attr("placeholder");
            let newPlaceholder = datepickerInput.attr("data-placeholder");
            datepickerInput.attr("placeholder",newPlaceholder)
            datepickerInput.attr("data-placeholder",oldPlaceholder)
            if($(this).is(":checked")){
                datepickerInput.datepicker();
                
            }else{
                datepickerInput.datepicker("destroy");
            }
            datepickerInput.val("").focus();
        }).trigger("change");
    })();
    function adjustCatWrap(){
        let wrapper = $(".cat-wrapper");
        let wrapClass = [
            "col-6 col-md-4",
            "col-6 col-md-4 col-xl-6",
        ]
        let index = Math.round(Math.random());
        for(let i = 0; i < wrapper.length; i++){
            if(index === 0){
                $(wrapper[i]).addClass(wrapClass[index]);
                $(wrapper[i+1]).addClass(wrapClass[index]);
                $(wrapper[i+2]).addClass(wrapClass[index]);
                index = 1;
                i += 2;
            }else{
                $(wrapper[i]).addClass(wrapClass[index]);
                $(wrapper[i+1]).addClass(wrapClass[index]);
                i += 1;
                index = 0;
            }
        }
        wrapper.removeClass("cat-wrapper");
    }
    if($(".cat-wrapper").length > 0 ){
        adjustCatWrap();
    }
    (function payForm(){
        $(".payment-method").change(function(){
            if($(this).is(":checked")){
                let form = $(`#${$(this).attr("data-destination")}`);
                $(".form-hidden").addClass("d-none");
                form.removeClass("d-none");
            }
        }).trigger("change")
    })();
    (function (){
        let field = $(".cart-operation");
        let add = field.find(".add-operation");
        let minus = field.find(".minus-operation");
        add.click(function(e){
            let input = $(this).parent().find("input");
            let value = parseInt(input.val());
            input.val(value + 1);
            e.preventDefault();
        })
        minus.click(function(e){
            let input = $(this).parent().find("input");
            let value = parseInt(input.val());
            if(value !== 1){
                input.val(value - 1);
            }
            e.preventDefault();
        })
        field.find("input").change(function(){
            let value = $(this).val();
            if(value < 1){
                $(this).val(1);
            }
        })
    })();
    (function(){
        let fileField = $(".file-reader");
        fileField.change(function(e){
            let imageCont = $(`#${$(this).attr("data-destination")}`);
            let tempPath = URL.createObjectURL(e.target.files[0]);
            imageCont.css("background-image",`url(${tempPath})`);
        });
    })();
    (function(){
        let grid = $(".grid-toggler");
        grid.click(function(event){
            grid.removeClass("active");
            $(this).addClass("active");
            let classname = $(this).attr("data-class");
            let target = $(this).attr("data-target");
            $(`.${target}`).attr("class",`${target} ${classname}`).find(".card").toggleClass("card-big");
            event.preventDefault();
        })
    })();
    (function(){
        $(".limit-characters").each(function(){
            var element = $(this);
            var limitCharacters = {
                elementText : element.text().trim(),
                charactersAccepted : element.attr("data-characters") || 200,
                newParagraph : $('<p class="newPara"></p>'),
                buttonType : element.attr("data-buttonType") || false,
            };
            limitCharacters.limitedText = limitCharacters.elementText.substr(0,limitCharacters.charactersAccepted);
            element.append(limitCharacters.newParagraph);
            element.children().not(".newPara").hide();
            limitCharacters.newParagraph.append(limitCharacters.limitedText);
            if(limitCharacters.buttonType == "attached"){
                limitCharacters.buttonElement = $('<a class="attached" href="#">...read more</a>');
                limitCharacters.button = limitCharacters.buttonElement;
                limitCharacters.newParagraph.append(limitCharacters.buttonElement);
            }else{
                limitCharacters.buttonElement = $(`<div class="d-block"><a href="#" class="${limitCharacters.buttonType} actionButton ">Read More</a></div>`);
                limitCharacters.button = limitCharacters.buttonElement.find("a");
                element.append(limitCharacters.buttonElement);
            }
            if(limitCharacters.elementText.length<200){
                limitCharacters.buttonElement.hide();
            }
            limitCharacters.button.click(function(e){
                limitCharacters.newParagraph.slideToggle(300);
                element.children().not(".newPara").slideToggle(300);
                $(this).toggleClass("expanded");
                if($(this).hasClass("attached")){
                    if($(this).hasClass("expanded")){
                        $(this).html("...read less");
                        $(this).parent().prev().append($(this));
                    }else{
                        $(this).html("...read more");
                        limitCharacters.newParagraph.append($(this));
                    }
                }else{
                    if($(this).hasClass("expanded")){
                        $(this).html("Read Less");
                    }
                    else{
                        $(this).html("Read More");
                    }
                }
                e.preventDefault();
            });
        });
    })()
    $(window).scroll(function(){
        let window = $(this);
        let scrollPos = window.scrollTop();
        function fixHeader(){
            let header = $(".site-header");
            if(scrollPos > header.height()){
                $(".top-header").hide();
                header.addClass("stick");
            }else{
                $(".top-header").show();
                header.removeClass("stick");
            }
        }
        if(isBrowser){
            fixHeader();
        }
        function closeFormWhenScrolled(){
            let element = $(".slider-section");
            if(scrollPos > (element.offset().top + element.outerHeight(true))){
                element.find(".section-toggler").removeClass("expanded");
                element.find("#advanced-form").slideUp();
            }
        }
        if($(".slider-section").length > 0 && isMobile){
            closeFormWhenScrolled();
        }
        (function(){
            let tabs = $(".nav-scrollable");
            let link = tabs.find(".nav-link");
            let selectBox = tabs.find("+.form-group .nav-select");
            link.each(function(){
                let scrollerDestination = $($(this).attr("href"));
                let destHeight = scrollerDestination.height();
                let destinationTopPosition = scrollerDestination.offset().top - 80;
                let destinationBottomPosition = destinationTopPosition + destHeight;
                if(destinationTopPosition <= scrollPos && destinationBottomPosition > scrollPos){
                    link.removeClass("active");
                    $(this).addClass("active");
                    selectBox.val($(this).attr("aria-controls"));
                }
            });
        })()
    });
})